export enum AccessRightBit {
  Read = 1,
  Edit = 2,
  Save = 4,
  Print = 8,
  AllRights = 16,
  NotWatermark = 32,
  //NotRedacted = 64,
  DocumentOwner = 128,
  RestrictVersions = 256,
}
